<template>
    <div class="account-box">
        <div class="pt-28 pb-32">
            <el-form :model="userInfo" :rules="rules" ref="userInfo" label-width="160px" class="demo-ruleForm"
                :hide-required-asterisk="true">
                <el-form-item :label="$t('旧密码')" prop="user_pwd">
                    <el-input :type="showPwd.pwd_show ? 'text' : 'password'" v-model="userInfo.user_pwd"
                        :placeholder="$t('请输入旧密码')">
                        <i class="iconfont cup mr-12" :class="showPwd.pwd_show ? 'icon-yanjing1' : 'icon-yanjing2'"
                            @click="handleShowpwd($event, 'pwd_show')" slot="suffix">
                        </i>
                    </el-input>
                </el-form-item>
                <el-form-item :label="$t('新密码')" prop="user_pwd_new">
                    <el-input :type="showPwd.pwd_new_show ? 'text' : 'password'" v-model="userInfo.user_pwd_new"
                        :placeholder="$t('请输入6-20位长度的密码')">
                        <i class="iconfont cup mr-12" :class="showPwd.pwd_new_show ? 'icon-yanjing1' : 'icon-yanjing2'"
                            slot="suffix" @click="handleShowpwd($event, 'pwd_new_show')">
                        </i>
                    </el-input>
                </el-form-item>
                <el-form-item :label="$t('确认密码')" prop="user_pwd_new_confirm">
                    <el-input :type="showPwd.pwd_new_confirm_show ? 'text' : 'password'"
                        v-model="userInfo.user_pwd_new_confirm" :placeholder="$t('请确认新密码')">
                        <i class="iconfont cup mr-12" slot="suffix"
                            :class="showPwd.pwd_new_confirm_show ? 'icon-yanjing1' : 'icon-yanjing2'"
                            @click="handleShowpwd($event, 'pwd_new_confirm_show')">
                        </i>
                    </el-input>
                </el-form-item>
                <div class="df aic jcsb pl-160">
                    <el-button type="primary" @click="submitForm">{{
                        $t("确认修改")
                        }}</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import Uploadcropper from "@comp/UploadCropper/avatar.vue";
import { updatePwd } from "@api/usercenter";

export default {
    components: { Uploadcropper },
    data() {
        return {
            userInfo: {
                user_pwd: "",
                user_pwd_new: "",
                user_pwd_new_confirm: "",
            },
            showPwd: {
                pwd_show: false,
                pwd_new_show: false,
                pwd_new_confirm_show: false
            },
            rules: {
                user_pwd: [
                    {
                        required: true,
                        message: this.$t("请输入旧密码"),
                        trigger: ["blur", "change"],
                    },
                ],
                user_pwd_new: [
                    {
                        required: true,
                        message: this.$t("请输入新密码"),
                        trigger: ["blur", "change"],
                    },
                ],
                user_pwd_new_confirm: [
                    {
                        required: true,
                        message: this.$t("请输入确认密码"),
                        trigger: ["blur", "change"],
                    },
                ],
            },
        };
    },
    methods: {
        // 确认修改
        submitForm() {

            this.$refs["userInfo"].validate(async (valid) => {
                if (valid) {
                    updatePwd({ ...this.userInfo }).then((res) => {
                        if (res.status == 200) {
                            this.$message({
                                type: "success",
                                message: res.msg,
                            });
                            // 刷新页面
                            setTimeout(() => {
                                // history.go(0)
                                this.$router.push({ path: "/" });
                                this.$bus.$emit('changeUserinfo', "1");
                            }, 3000);

                        }
                    });
                }
            });
        },

        handleShowpwd(e, type) {
            // 阻止冒泡
            e.stopPropagation();
            this.showPwd[type] = !this.showPwd[type];
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep() {
    .el-input--suffix .el-input__inner {
        padding-right: 40px;
        // 单行溢出隐藏
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .el-input,
    .el-textarea {
        max-width: 368px;
    }

    .el-radio {
        margin-right: 16px;
    }

    .el-radio__label {
        font-size: 14px;
    }

    .el-select {}
}
</style>